import { render, staticRenderFns } from "./modalInformacionUsuario.vue?vue&type=template&id=9b71e1a2"
import script from "./modalInformacionUsuario.vue?vue&type=script&lang=js"
export * from "./modalInformacionUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports